import { z } from 'zod';

export const RECONCILIATION_COMMENT_MAX_LENGTH = 500;

export const reconciliationCommentsSchema = z.object({
  comment: z.string().trim().max(RECONCILIATION_COMMENT_MAX_LENGTH).optional(),
  internalComment: z
    .string()
    .trim()
    .max(RECONCILIATION_COMMENT_MAX_LENGTH)
    .optional(),
});

export type ReconciliationComments = z.infer<
  typeof reconciliationCommentsSchema
>;
